import * as React from 'react'
import { RefObject } from 'react'

type Props = {
  className?: string
  text: string
  readOnly?: boolean
  onChange: (text: string) => void
  placeholder?: string
}

type State = {
  value: string
}

export class TextEntry extends React.Component<Props, State> {
  myRef: RefObject<HTMLTextAreaElement>
  constructor(props: Props) {
    super(props)
    this.myRef = React.createRef()
    this.state = { value: props.text }
  }

  updateCommentIfEdited = (e: React.FocusEvent<HTMLTextAreaElement>) => {
    if (this.props.text !== this.state.value) {
      this.props.onChange(this.state.value)
    }
  }

  onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.setState({ value: e.target.value })
    this.autoExpand(e.target)
  }

  public componentDidUpdate(prevProps: Props) {
    if (this.props.text !== prevProps.text) {
      this.setState({ value: this.props.text })
    }
  }

  public componentDidMount() {
    if (this.myRef.current !== null) {
      this.autoExpand(this.myRef.current)
    }
  }

  // based upon https://gomakethings.com/automatically-expand-a-textarea-as-the-user-types-using-vanilla-javascript/
  autoExpand = function(textArea: HTMLTextAreaElement) {
    // Reset field height
    textArea.style.height = 'inherit'

    // Get the computed styles for the element
    var computed = window.getComputedStyle(textArea)

    var text = textArea.value
    // the computed height is always at least 2 lines, so special case if the text will fit on one line
    // the constant 10 is a bit o a hack
    var textFitsOnOneLine = text.length < 10 && !!!/\r|\n/.exec(text)

    // Calculate the height
    var height =
      parseFloat(computed.borderTopWidth || '0') +
      parseFloat(computed.paddingTop || '0') +
      (textFitsOnOneLine ? parseFloat(computed.lineHeight || '0') : textArea.scrollHeight) +
      parseFloat(computed.paddingBottom || '0') +
      parseFloat(computed.borderBottomWidth || '0')

    textArea.style.height = height + 'px'
  }

  public render(): JSX.Element {
    if (!!!this.props.readOnly) {
      return (
        <textarea
          className={(this.props.className || '') + ' form-control auto-grow-text'}
          onBlur={this.updateCommentIfEdited}
          onChange={this.onChange}
          value={this.state.value || ''}
          ref={this.myRef}
          placeholder={this.props.placeholder || ''}
        />
      )
    } else {
      return <p>{this.props.text}</p>
    }
  }
}

export default TextEntry
